// TODO: should this file be renamed?
// TODO: should this be part of the repo?
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { query } from '@/api/looker/utils/query';
import { useLookerModelId } from '@/hooks/looker/use-looker-model-id';
import { useLookerSdk } from '@/hooks/useLookerSdk';
import { IPCSRepository } from '@/pcs/domain/repositories/pcs.repository';

export type PCS = {
  id: string;
  label: string;
};

export type ListPCSData = {
  pcss: PCS[];
};

type useListPCSsInput = {
  filters?: IPCSRepository.Filters;
  assetFullFrontendId: string;
};
export function useListPCSs({
  filters,
  assetFullFrontendId,
}: useListPCSsInput): UseQueryResult<ListPCSData> {
  const coreSDK = useLookerSdk();
  const model = useLookerModelId();

  return useQuery({
    queryKey: ['api/looker/pcs-list-pcss', model, filters, assetFullFrontendId],
    async queryFn(): Promise<ListPCSData> {
      const queryFilters: Record<string, string> = {
        'frontend_id_mapping.full_frontend_system_id': assetFullFrontendId
          ? `${assetFullFrontendId}`
          : '',
        'frontend_id_mapping.accure_level': 'pcs',
      };
      const pcss = await query(coreSDK)
        .from<{
          'frontend_id_mapping.full_frontend_id': string;
          'frontend_id_mapping.accure_id': string;
        }>({
          model,
          view: 'frontend_id_mapping',
          fields: ['frontend_id_mapping.full_frontend_id'],
          sorts: ['frontend_id_mapping.full_frontend_id asc'],
          filters: queryFilters,
        })
        .toMany<PCS>((result) => ({
          id: result['frontend_id_mapping.accure_id'],
          label: result['frontend_id_mapping.full_frontend_id'],
        }));
      return { pcss };
    },
  });
}
